import React, { useState, useEffect } from 'react';
import { TabView, TabPanel } from 'primereact/tabview';
import TravellerDetails from './travellerdetails';
import InsuranceDetails from './insurancedetails';
import PassportDetails from './passportdetails';
import TravelDetails from './traveldetails';

import { useSelector } from "react-redux";
import { travelTabs, setTravelTab } from '../../services/store/userSlice';
import { useDispatch } from 'react-redux';
import TeamTravel from './team-travel';
import TravelDesk from './travel-desk';
import BuHead from './BuHead';
import HrHead from './HrHead';
import CeoHead from './CeoHead';
import { hasPermission } from '../../components/protected/ProtectedSection';
import { Team_Travel, Travel_Employee, Travel_Desk, BU_Head, HR_Head, CEOs } from "../../config/permissions"

function Travels() {
    const travelTab = useSelector(travelTabs);
    const dispatch = useDispatch();
    // const [selectedTab, setSelectedTab] = useState(0);

    useEffect(() => {
        dispatch(setTravelTab(0));
    }, []);

    const onChangeTab = (e) => {
        dispatch(setTravelTab(e?.index));
    };
    console.log(travelTab, "travelTabs");

    return (
        <div>
            <TabView>
                {hasPermission(Travel_Employee) && (
                    <TabPanel header="My Travel">
                        <TabView activeIndex={travelTab} onTabChange={(e) => { onChangeTab(e); }}>
                            <TabPanel header="Traveller Details" disabled={travelTab === 0 ? false : true}>
                                <TravellerDetails />
                            </TabPanel>
                            <TabPanel header="Travel Details" disabled={travelTab === 1 ? false : true}>
                                <TravelDetails />
                            </TabPanel>
                            <TabPanel header="Passport Details" disabled={travelTab === 2 ? false : true}>
                                <PassportDetails />
                            </TabPanel>
                            <TabPanel header="Insurance Details" disabled={travelTab === 3 ? false : true}>
                                <InsuranceDetails />
                            </TabPanel>
                        </TabView>
                    </TabPanel>
                )}
                {hasPermission(Team_Travel) && (
                    <TabPanel header="Team Travel">
                        <TeamTravel />
                    </TabPanel>
                )}
                {hasPermission(Travel_Desk) && (
                    <TabPanel header="Travel Desk">
                        <TravelDesk />
                    </TabPanel>
                )}
                {hasPermission(BU_Head) && (
                    <TabPanel header="BU Head">
                        <BuHead />
                    </TabPanel>
                )}
                {hasPermission(HR_Head) && (
                    <TabPanel header="HR Head">
                        <HrHead />
                    </TabPanel>
                )}
                {hasPermission(CEOs) && (
                    <TabPanel header="CEOs">
                        <CeoHead />
                    </TabPanel>
                )}
            </TabView>


        </div>
    );
}

export default Travels;